import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng/errorBoundary';
import { rel } from '../../../../../utils/rel';
import { formatImage } from '../../../../../utils/formatImg';
import { formatDateTime } from '../../../../utils/index';
import { getCommentCount, getXiNewsList } from '../../../../../services/api';
/**
 * for this page
 */
import Headline from '../../../../components/headline';
class NewsList extends React.PureComponent {
    state = {
        newsData: [],
        loadMore: true,
        commentData: {},
    };
    static propTypes = {
        headLineNew: PropTypes.array,
        newsList: PropTypes.array,
    };

    componentDidMount() {
        this.getFirstPageNews();
    }

    // 分页获取新闻数据
    getCustomNewsTfList = async () => {
        const len = this.state.newsData.length;
        const res = await getXiNewsList({
            start: len,
            len: 10,
        });

        return {
            total: res.data.total,
            news: res.data.newsstream,
        };
    };
    // 获取每次加载文章的评论数
    getCommentCount = async data => {
        const commentUrl = [];

        data.map(item => {
            commentUrl.push(item.commentUrl);

            return true;
        });

        const countsData = await getCommentCount(commentUrl);

        const commentDataC = {};

        countsData.map(item => {
            commentDataC[item.doc_url] = item.count;

            return true;
        });

        this.setState({
            commentData: { ...this.state.commentData, ...commentDataC },
        });
        // console.log(this.state.commentData);

        return true;
    };
    // 获取首页数据
    getFirstPageNews() {
        this.getCommentCount(this.props.newsList);

        this.setState({
            newsData: this.props.newsList,
        });
    }
    // 点击加载更多
    getList = async () => {
        const req = await this.getCustomNewsTfList();

        const { news, total } = req;

        this.getCommentCount(news);

        const nextNewsData = this.state.newsData;

        const result = nextNewsData.concat(news);

        // 全部加载完成，隐藏按钮
        if (this.state.newsData.length === total) {
            this.setState({
                newsData: result,
                loadMore: false,
            });
        } else {
            this.setState({
                newsData: result,
            });
        }
    };

    render() {
        // console.log('NewsList=', this.props);
        const { headLineNew } = this.props;

        /**
         * 组件分发数据
         */
        const newsListItem = item => {
            return (
                <div className={styles.newsListItem} key={item.id}>
                    <a href={item.url} target="_blank" rel={rel}>
                        {/* {item.thumbnails.image ? <img src={imgUrl} alt={item.title} title={item.title} /> : null} */}
                        {item.thumbnails.image && item.thumbnails.image[0] ? (
                            <img
                                src={formatImage(item.thumbnails.image[0].url, 140, 118)}
                                alt={item.title}
                                title={item.title}
                            />
                        ) : null}
                        <div className={styles.txtWrapper}>
                            <h4>{item.title}</h4>
                            <p>
                                <span className={styles.rec_time}>{formatDateTime(item.newsTime, 5)}</span>
                                <span className={styles.rec_num}>{this.state.commentData[item.commentUrl]}</span>
                            </p>
                        </div>
                    </a>
                </div>
            );
        };

        return (
            <div className={styles.content}>
                <Headline content={headLineNew} commentCount={this.state.commentData[headLineNew[0].commentUrl]} />
                <div className={styles.listBox}>
                    {this.state.newsData.map(item => {
                        return newsListItem(item);
                    })}
                    <div className={this.state.loadMore ? styles.loadMore : styles.hidden}>
                        <a href="javascript:void(0)" onClick={this.getList}>
                            + 更多新闻
                        </a>
                    </div>
                </div>
            </div>
        );
    }
}

export default errorBoundary(NewsList);
